<template>
  <el-dialog
    :title="item.exclusiveId ? '修改' : '新建' + '敏感因素'"
    :visible="visible"
    width="400px"
    :before-close="handleCancel"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="demo-form-inline">
      <el-form-item label="敏感因素名称" prop="exclusiveName">
        <el-input v-model="form.exclusiveName" placeholder="请输入敏感因素名称"></el-input>
      </el-form-item>
      <el-form-item label="敏感因素类别" prop="exclusiveTypeId">
        <el-select v-model="form.exclusiveTypeId" placeholder="请选择类别">
          <el-option v-for="item in exclusveTypeList" :label="item.name" :value="item.dataId"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <el-button type="primary" @click="onSubmit">立即创建</el-button>-->
<!--        <el-button>取消</el-button>-->
<!--      </el-form-item>-->
    </el-form>
<!--    <span-->
<!--      ><el-input-->
<!--        v-model="exclusiveName"-->
<!--        placeholder="请输入敏感因素名称"-->
<!--      ></el-input>-->
<!--    </span>-->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateExclusiveName, saveWindfarmExclusive, getExclusiveTypeList } from '../service';
import to from 'await-to-js';
export default {
  props: {
    visible: {
      type: Boolean
    },
    item: {
      type: Object
    },
    geometryInfo: {
      type: String
    }
  },
  data() {
    return {
      exclusveTypeList: [],
      form: {
        exclusiveName: '',
        exclusiveTypeId: undefined
      },
      rules: {
        exclusiveName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        exclusiveTypeId: [
          { required: true, message: '请选择类别', trigger: ['blur','change'] }
        ],
      }
    };
  },
  mounted() {
    this.getExclusiveTypeList();
    this.$nextTick(() => {
      this.form.exclusiveName = this.item?.exclusiveName;
      this.form.exclusiveTypeId = this.item?.exclusiveTypeId;
    });
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    getExclusiveTypeList(){
      getExclusiveTypeList().then(res => {
        this.exclusveTypeList = res.data.list;
      });
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this._handleSubmit();
        }
      });
    },
    async _handleSubmit() {
      const requestMethod = this.item?.exclusiveId
              ? updateExclusiveName
              : saveWindfarmExclusive;
      let parms = {
        exclusiveName: this.form.exclusiveName,
        exclusiveTypeId: this.form.exclusiveTypeId,
        projectId: this.$route.query.projectId,
        avoidDiatance: this.item?.avoidDiatance || 0,
        geometryInfo: this.geometryInfo
      };
      if (this.item?.exclusiveId) {
        parms = {
          ...parms,
          exclusiveId: this.item?.exclusiveId,
          geometryInfo: this.item.geometryInfo,
          exclusiveName: this.form.exclusiveName,
          exclusiveTypeId: this.form.exclusiveTypeId
        };
        // delete parms.exclusiveName;
      }
      const [err, result] = await to(requestMethod(parms));
      if (!err && result.code === 0) {
        this.$message.success(result.message || '操作成功');
        this.handleCancel();
        // this.$emit('saveBack');
      }
    }
  }
};
</script>
<style scoped lang="less">
  .el-select{
    width:100%
  }
</style>
